import {RefObject, useCallback, useEffect} from 'react';
import {RUNTIME_CSS_VARS} from 'core/constants';
import useResizeObserver, {ResizeHandler, ResizeObserverBoxOptions} from 'use-resize-observer';
import {setCssVar} from 'core/helpers';

export const useElementHeight = (
    element: RefObject<HTMLElement>,
    cssVarName: (typeof RUNTIME_CSS_VARS)[keyof typeof RUNTIME_CSS_VARS],
    boxModel: ResizeObserverBoxOptions = 'border-box',
) => {
    const handleHeightResize = useCallback<ResizeHandler>(
        ({height}) => {
            setCssVar({
                cssVarName,
                unit: 'px',
                value: height || 0,
            });
        },
        [cssVarName],
    );

    useResizeObserver({box: boxModel, onResize: handleHeightResize, ref: element});

    // сбрасываем переменную при анмаунте, чтобы для элементов, живущих не всю сессию
    // (например, на конкретной странице), высота не "залипала" после ухода со страницы
    useEffect(() => {
        return () => {
            setCssVar({cssVarName, unit: 'px', value: 0});
        };
    }, [cssVarName]);
};
